import { useStaticQuery, graphql } from 'gatsby';

import type { StrapiHeaderNavItem } from '@customTypes/strapiData';

export const useHeaderNav = () => {
  const {
    allStrapiHeaderNav: { nodes },
  } = useStaticQuery(graphql`
    {
      allStrapiHeaderNav {
        nodes {
          title
          rank
          url
          externalUrl
          icon {
            localFile {
              publicURL
              childImageSharp {
                gatsbyImageData(aspectRatio: 1, width: 24, height: 24, layout: FIXED)
              }
            }
          }
          items {
            title
            url
            externalUrl
          }
        }
      }
    }
  `);

  return nodes.sort((a: StrapiHeaderNavItem, b: StrapiHeaderNavItem) => a.rank - b.rank);
};
